export class SignPlacementPriceType {
  constructor(readonly label: string, readonly ordinal: number) {}
}

export const SIGN_PLACEMENT_PRICE_TYPE_CHOICES = {
  ADHESIVE_BOARD: new SignPlacementPriceType('Kleefbord', 0),
  IP_BOARD: new SignPlacementPriceType('IP-bord', 1)
};

export const SIGN_PLACEMENT_PRICE_TYPE_CHOICES_ARRAY = Object.values(
  SIGN_PLACEMENT_PRICE_TYPE_CHOICES
);
